import { createSlice } from "@reduxjs/toolkit";

export const balanceSlice = createSlice({
  name: "balance",
  initialState: {
    currency: "USD",
    balance: 0,
    isBroker: 0
  },
  reducers: {
    setBalance: (state, action) => {
      return {
        currency: action.payload.currency,
        balance: action.payload.balance, // تأكد من تحديث الرصيد أيضًا
        isBroker: action.payload.isBroker,
        centerName: action.payload.centerName,
        address: action.payload.address,
        city: action.payload.city,
      };
    },
  },
});

// Export action creators
export const { setBalance } = balanceSlice.actions;

// Export reducer
export default balanceSlice.reducer;
